import axios from 'axios';
import { makeUseAxios } from 'axios-hooks';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const axiosInstance = axios.create({
  baseURL: `${env.reznorHostname}/api`,
});

const useAxios = makeUseAxios({
  axios: axiosInstance,
});

export const { useLazyApi: useLazyBaseApi, useNewApi: useBaseApi } =
  makeApiHooks(useAxios);
